import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserShield } from '@fortawesome/free-solid-svg-icons';
import AuthContext from '../context/AuthContext';

const SetupAdmin = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    password2: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isFirstUser, setIsFirstUser] = useState(false);
  const [checking, setChecking] = useState(true);
  
  const { setAuth, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    const checkFirstUser = async () => {
      try {
        setChecking(true);
        // Проверяем, есть ли уже пользователи в системе
        const res = await axios.get('/api/auth/check-first-user');
        setIsFirstUser(res.data.isFirstUser);
        setChecking(false);
      } catch (err) {
        setError('Ошибка при проверке состояния системы');
        setChecking(false);
      }
    };
    
    checkFirstUser();
  }, []);
  
  useEffect(() => {
    // Если пользователь уже аутентифицирован, перенаправляем его
    if (isAuthenticated) {
      navigate('/templates');
    }
  }, [isAuthenticated, navigate]);
  
  const { name, email, password, password2 } = formData;
  
  const onChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const onSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    if (password !== password2) {
      setError('Пароли не совпадают');
      setLoading(false);
      return;
    }
    
    try {
      const res = await axios.post('/api/auth/setup-admin', {
        name,
        email,
        password
      });
      
      // Сохраняем токен в localStorage
      localStorage.setItem('token', res.data.token);
      
      // Обновляем контекст аутентификации
      setAuth(true, res.data.user);
      
      // Перенаправляем на главную страницу
      navigate('/templates');
    } catch (err) {
      setError(err.response?.data?.message || 'Ошибка при настройке администратора');
      setLoading(false);
    }
  };

  if (checking) {
    return (
      <div className="text-center my-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Загрузка...</span>
        </div>
        <p className="mt-3">Проверка состояния системы...</p>
      </div>
    );
  }
  
  if (!isFirstUser) {
    return (
      <div className="alert alert-info my-5">
        <h4 className="alert-heading">Система уже настроена!</h4>
        <p>Администратор уже создан. Пожалуйста, войдите в систему или запросите приглашение у администратора.</p>
        <hr />
        <div className="d-flex justify-content-end">
          <button className="btn btn-primary" onClick={() => navigate('/login')}>
            Перейти на страницу входа
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-md-6 offset-md-3">
        <div className="auth-form card shadow">
          <div className="card-body">
            <h2 className="text-center mb-4">
              <FontAwesomeIcon icon={faUserShield} className="me-2" />
              Первичная настройка системы
            </h2>
            <p className="text-center text-muted mb-4">
              Создайте первого администратора (директора) для управления системой
            </p>
            
            {error && <div className="alert alert-danger">{error}</div>}
            
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label htmlFor="name" className="form-label">Имя</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={name}
                  onChange={onChange}
                  required
                />
              </div>
              
              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={email}
                  onChange={onChange}
                  required
                />
              </div>
              
              <div className="mb-3">
                <label htmlFor="password" className="form-label">Пароль</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  name="password"
                  value={password}
                  onChange={onChange}
                  minLength="6"
                  required
                />
              </div>
              
              <div className="mb-3">
                <label htmlFor="password2" className="form-label">Подтверждение пароля</label>
                <input
                  type="password"
                  className="form-control"
                  id="password2"
                  name="password2"
                  value={password2}
                  onChange={onChange}
                  minLength="6"
                  required
                />
              </div>
              
              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={loading}
              >
                {loading ? (
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                ) : (
                  <FontAwesomeIcon icon={faUserShield} className="me-2" />
                )}
                Создать администратора
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupAdmin; 